import { echartLine } from '../common';
import { handlerDesactivarFiltro } from './common';

export function echartUsuarisTotals(vis, datos) {
  echartLine(
    datos,
    true,
    1,
    "ÚS D'EMT: USUARIS TOTALS",
    'Viatges',
    'chartUsuarisTotals',
    'no_dataUsuarisTotals',
    undefined,
    undefined,
    undefined,
    undefined,
    false,
  );
}

export function usdEmtUsuarisTotals() {
  handlerDesactivarFiltro();
  $('#idFieldsFilterEmtUsLinea').hide();
  $('#idFieldsFilterEmtUsTitol').hide();
}
